export default {
  show: false,
  images: [],
  item: {}
};
